import { Layout } from '@faceup/ui-base'
import { LogoSize } from '@faceup/utils'
import type { ReactNode } from 'react'
import { useClient } from '../App/ClientProvider'
import { Footer } from './Footer/Footer'
import { Header } from './Header/Header'
import { InstitutionLogo } from './InstitutionLogo'
import { LanguageDropdown } from './LanguageDropdown/LanguageDropdown'

const { Content } = Layout

type PlainLayoutProps = {
  children?: ReactNode
  isFooterHidden?: boolean
}

export const PlainLayout = (props: PlainLayoutProps) => {
  const { client } = useClient()
  const hiddenFooter = props.isFooterHidden || client === 'iframe'

  return (
    <>
      {client !== 'iframe' && (
        <Header>
          <InstitutionLogo name={null} logoUrl={null} logoSize={LogoSize.md} />
          <LanguageDropdown />
        </Header>
      )}
      <Layout
        style={{
          minHeight: 'calc(100vh - 32px)',
          background: 'transparent',
        }}
      >
        <Content
          style={{ display: 'flex', flex: 1, flexDirection: 'column', padding: '32px 2em 20px' }}
        >
          {props.children}
        </Content>
        {!hiddenFooter && (
          <div className='mx-8'>
            <Footer />
          </div>
        )}
      </Layout>
    </>
  )
}
